import { HORIZONTAL_MENU_ITEM, MENU_ITEMS } from '../assets/data/menu-items';
import { isAllowed } from '../context/usePermissions';
// Children learn their group's key, so opening a page inside a group (a deep link, a
// refresh) also opens and highlights the group.
const withParentKeys = (items, parentKey) =>
  (items || []).map((item) => ({
    ...item,
    ...(parentKey && !item.parentKey ? { parentKey } : {}),
    ...(item.children ? { children: withParentKeys(item.children, item.key) } : {}),
  }));
const MENU = withParentKeys(MENU_ITEMS);
const HORIZONTAL_MENU = withParentKeys(HORIZONTAL_MENU_ITEM);
export const getMenuItems = () => {
  return MENU;
};
export const getHorizontalMenuItems = () => {
  return HORIZONTAL_MENU;
};
// Drops items the admin can't open, and groups left with no children.
export const filterMenuItems = (items, can) =>
  (items || []).reduce((visible, item) => {
    if (!isAllowed(can, item.permission)) return visible;
    if (item.children) {
      const children = filterMenuItems(item.children, can);
      if (children.length) visible.push({ ...item, children });
    } else {
      visible.push(item);
    }
    return visible;
  }, []);
export const findAllParent = (menuItems, menuItem) => {
  let parents = [];
  const parent = findMenuItem(menuItems, menuItem.parentKey);
  if (parent) {
    parents.push(parent.key);
    if (parent.parentKey) {
      parents = [...parents, ...findAllParent(menuItems, parent)];
    }
  }
  return parents;
};
// The menu item for a URL: an exact match, or else the deepest item the path sits under,
// so detail pages keep their list page highlighted (/product/edit/1 -> /product).
export const getMenuItemFromURL = (items, url) => {
  if (!url) return undefined;
  let best;
  const visit = (list) => {
    for (const item of list || []) {
      const u = item.url;
      if (u && (url === u || url.startsWith(u.endsWith('/') ? u : `${u}/`)) && (!best || u.length > best.url.length)) {
        best = item;
      }
      if (item.children) visit(item.children);
    }
  };
  visit(Array.isArray(items) ? items : [items]);
  return best;
};
export const findMenuItem = (menuItems, menuItemKey) => {
  if (menuItems && menuItemKey) {
    for (const item of menuItems) {
      if (item.key === menuItemKey) {
        return item;
      }
      const found = findMenuItem(item.children, menuItemKey);
      if (found) return found;
    }
  }
  return null;
};